import { api } from './apiInstances';

const getAndSaveFiltersUrl = '/v1/PartesTrabajo/partesTrabajoDiario/filtros/me';

export const saveFilters = async (formatedFilters) => {
  const savedFilters = await api.post(getAndSaveFiltersUrl, formatedFilters);

  return savedFilters.data;
};

export const getSavedFilters = async (userType) => {
  const queryParams = new URLSearchParams();

  queryParams.append('tipoFiltroUsuario', userType);

  const savedFilters = await api.get(getAndSaveFiltersUrl.concat(`?${queryParams.toString()}`));

  return savedFilters.data;
};
